import React, { Component } from "react";
import { connect } from "react-redux";

import { Container, WebContainer, Spinner } from "app/NativeComponents/common";
import { Header } from "app/NativeComponents/snippets";

import Body from "./Body";

import {
  getPartnerAnalytics,
  savePartnerInfo,
  changeTab,
  toggleDrawer,
  appRedirect
} from "app/NativeActions";

class PartnerDashboard extends Component {
  componentDidMount() {
    this.props.changeTab("settings");
    this.props.getPartnerAnalytics({ token: this.props.token, type: "load" });

    if (this.props.user.canceled == 1 || this.props.onboarding == true) {
      this.props.toggleDrawer(false);
    } else {
      this.props.toggleDrawer(true);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.open == true) {
      //this.props.toggleDrawer(false);
    }
  }

  handleBack() {
    if (this.props.onboarding == false && this.props.user.canceled != 1) {
      this.props.appRedirect({ redirect: "main" });
    } else if (this.props.onboarding == true && this.props.user.canceled != 1) {
      this.props.appRedirect({
        redirect: "goBack",
        payload: { type: "billing" }
      });
    } else if (this.props.user.canceled == 1) {
      this.props.appRedirect({
        redirect: "goBack",
        payload: { type: "canceled" }
      });
    }
  }

  renderSpinner() {
    if (this.props.loading || this.props.refreshing) {
      return <Spinner />;
    }
  }

  render() {
    if (!this.props.loading) {
      return (
        <Container>
          <Header
            title="Partner Dashboard"
            leftButtonIcon={
              this.props.onboarding == true || this.props.user.canceled == 1
                ? "arrow-back"
                : "logo"
            }
            leftButtonAction={
              this.props.onboarding == true || this.props.user.canceled == 1
                ? () => {
                    this.handleBack();
                  }
                : () => {}
            }
            rightButtonIcon={"refresh"}
            rightButtonAction={() => {
              this.props.getPartnerAnalytics({
                token: this.props.token,
                type: "refresh"
              });
            }}
          />
          <WebContainer type="2xl">
            <Body {...this.props} />
          </WebContainer>
          {this.renderSpinner()}
        </Container>
      );
    } else {
      return (
        <Container>
          <Spinner />
        </Container>
      );
    }
  }
}

const mapStateToProps = ({ auth, native, drawer, partner, settings }) => {
  const { token, user, onboarding } = auth;
  const { device } = native;
  const { dark_mode, colors } = settings;
  const { stats, open } = drawer;
  const {
    users,
    promo_codes,
    refreshing,
    loading,
    is_partner,
    partner_info,
    accepted_affiliate_latest_terms
  } = partner;
  const partner_stats = partner.stats;

  return {
    token,
    user,
    device,
    stats,
    partner_stats,
    users,
    promo_codes,
    refreshing,
    loading,
    open,
    dark_mode,
    colors,
    is_partner,
    partner_info,
    accepted_affiliate_latest_terms,
    onboarding
  };
};

export default connect(mapStateToProps, {
  getPartnerAnalytics,
  savePartnerInfo,
  changeTab,
  appRedirect,
  toggleDrawer
})(PartnerDashboard);
